import {useEffect, useRef, useState} from "react";

export function useLazySection(Component, options = {}) {
    const ref = useRef(null);
    const [visible, setVisible] = useState(false);

    useEffect(() => {
        const element = ref.current;
        if (!element) return;

        // fallback (SSR / старые браузеры)
        if (typeof IntersectionObserver === "undefined") {
            setVisible(true);
            Component?.preload?.();
            return;
        }

        const observer = new IntersectionObserver(
            ([entry]) => {
                if (entry.isIntersecting) {
                    setVisible(true);

                    // preload компонента
                    Component?.preload?.();

                    observer.unobserve(element);
                }
            },
            {
                rootMargin: "400px",
                threshold: 0,
                ...options
            }
        );

        observer.observe(element);

        return () => {
            observer.unobserve(element);
            observer.disconnect();
        };
    }, [Component]);

    return [ref, visible];
}
